const dealerCityState = (dealer) => {
  if (dealer.attributes["city-state"] && (dealer.attributes['primary-address1'])) {
    return `${dealer.attributes["city-state"]} ${dealer.attributes["zip"] && dealer.attributes["zip"]}`
  }
}

export default dealerCityState